import { Action } from 'redux';

export const SHOW_REPORTS_ORDER_ACTION_MODAL = 'reports-orders/SHOW_REPORTS_ORDER_ACTION_MODAL';
export const HIDE_REPORTS_ORDER_ACTION_MODAL = 'reports-orders/HIDE_REPORTS_ORDER_ACTION_MODAL';
export const SHOW_REPORTS_ORDER_EDIT_MODAL = 'reports-orders/SHOW_REPORTS_ORDER_EDIT_MODAL';
export const HIDE_REPORTS_ORDER_EDIT_MODAL = 'reports-orders/HIDE_REPORTS_ORDER_EDIT_MODAL';
export const SHOW_REPORTS_ORDER_CLONE_MODAL = 'reports-orders/SHOW_REPORTS_ORDER_CLONE_MODAL';
export const HIDE_REPORTS_ORDER_CLONE_MODAL = 'reports-orders/HIDE_REPORTS_ORDER_CLONE_MODAL';
export const SHOW_REPORTS_ORDER_DELETE_MODAL = 'reports-orders/SHOW_REPORTS_ORDER_DELETE_MODAL';
export const HIDE_REPORTS_ORDER_DELETE_MODAL = 'reports-orders/HIDE_REPORTS_ORDER_DELETE_MODAL';
export const GET_REPORTS_ORDER_BY_STATUS = 'report-orders/GET_REPORTS_ORDER_BY_STATUS';
export const SET_REPORTS_ORDER_BY_STATUS = 'report-orders/SET_REPORTS_ORDER_BY_STATUS';

export const GET_OPTION_FIELDS = 'report-orders/GET_OPTION_FIELDS';
export const getOptionFieldsReport = (data: OptionFieldsPayload) => {
  return {
    type: GET_OPTION_FIELDS,
    payload: data,
  };
};
export const SET_OPTION_FIELDS = 'report-orders/SET_OPTION_FIELDS';
export const setOptionFields = (data: OptionFields) => ({
  type: SET_OPTION_FIELDS,
  payload: data,
});
export interface SetOptionFieldsAction extends Action<typeof SET_OPTION_FIELDS> {
  readonly payload: OptionFields;
}

export const GET_OREDER_FULFILLMENTS = 'report-orders/GET_OREDER_FULFILLMENTS';
export const getOrderFulfillments = (data: SelectReportData) => ({
  type: GET_OREDER_FULFILLMENTS,
  payload: data,
});

export const SET_OREDER_FULFILLMENTS = 'report-orders/SET_OREDER_FULFILLMENTS';
export const setOrderFulfillments = (data: ReadonlyArray<ReportsFulfillmentTable>) => ({
  type: SET_OREDER_FULFILLMENTS,
  payload: data,
});
export interface SetOrderFulfillmentsAction extends Action<typeof SET_OREDER_FULFILLMENTS> {
  readonly payload: ReadonlyArray<ReportsFulfillmentTable>;
}

export const GET_ORDER_SUMMARY = 'report-orders/GET_ORDER_SUMMARY';
export const getOrderSummarys = (data: SelectReportData) => ({
  type: GET_ORDER_SUMMARY,
  payload: data,
});

export const SET_ORDER_SUMMARY = 'report-orders/SET_OREDER_SUMMARY';
export const setOrderSummarys = (data: ReadonlyArray<OrderSummaryTable>) => ({
  type: SET_ORDER_SUMMARY,
  payload: data,
});
export interface SetOrderSummaryAction extends Action<typeof SET_ORDER_SUMMARY> {
  readonly payload: ReadonlyArray<OrderSummaryTable>;
}

export const getReportOrderByStatus = (data: SelectReportData) => ({
  type: GET_REPORTS_ORDER_BY_STATUS,
  payload: data,
});

export const setReportOrderByStatus = (data: ReadonlyArray<OrderReportTable>) => {
  return {
    type: SET_REPORTS_ORDER_BY_STATUS,
    payload: data,
  };
};
export const GET_ORDER_REPORTS = 'reports-orders/GET_ORDER_REPORTS';
export const getOrderReports = (data: SelectReportData) => ({
  type: GET_ORDER_REPORTS,
  payload: data,
});

export const SET_ORDER_REPORTS = 'reports-orders/SET_ORDER_REPORTS';
export const setOrederReports = (data: ReadonlyArray<OrderReportTable>) => {
  return {
    type: SET_ORDER_REPORTS,
    payload: data,
  };
};
//  temp permit order
export const GET_TEMP_ORDER_REPORTS = 'reports-orders/GET_TEMP_ORDER_REPORTS';
export const getTemporaryOrderReports = (data: SelectReportData) => ({
  type: GET_TEMP_ORDER_REPORTS,
  payload: data,
});

export const SET_TEMP_ORDER_REPORTS = 'reports-orders/SET_TEMP_ORDER_REPORTS';
export const setTemporaryOrderReports = (data: ReadonlyArray<OrderReportTable>) => {
  return {
    type: SET_TEMP_ORDER_REPORTS,
    payload: data,
  };
};
//  temp permit order

//  temp permit Account order
export const GET_TEMP_DRIVER_PERMIT = 'reports-orders/GET_TEMP_DRIVER_PERMIT';
export const getTempDriverPermit = (data: any) => ({
  type: GET_TEMP_DRIVER_PERMIT,
  payload: data,
});

export const SET_TEMP_DRIVER_PERMIT = 'reports-orders/SET_TEMP_DRIVER_PERMIT';
export const setTempDriverPermit = (data: ReadonlyArray<OrderReportTable>) => {
  return {
    type: SET_TEMP_DRIVER_PERMIT,
    payload: data,
  };
};
//  temp permit Account order
export const showReportsOrdersActionModal = () => {
  return {
    type: SHOW_REPORTS_ORDER_ACTION_MODAL,
  };
};

export const hideReportsOrdersActionModal = () => {
  return {
    type: HIDE_REPORTS_ORDER_ACTION_MODAL,
  };
};

export const showReportsOrdersEditModal = () => {
  return {
    type: SHOW_REPORTS_ORDER_EDIT_MODAL,
  };
};

export const hideReportsOrdersEditModal = () => {
  return {
    type: HIDE_REPORTS_ORDER_EDIT_MODAL,
  };
};

export const showReportsOrdersCloneModal = () => {
  return {
    type: SHOW_REPORTS_ORDER_CLONE_MODAL,
  };
};

export const hideReportsOrdersCloneModal = () => {
  return {
    type: HIDE_REPORTS_ORDER_CLONE_MODAL,
  };
};

export const showReportsOrdersDeleteModal = () => {
  return {
    type: SHOW_REPORTS_ORDER_DELETE_MODAL,
  };
};

export const hideReportsOrdersDeleteModal = () => {
  return {
    type: HIDE_REPORTS_ORDER_DELETE_MODAL,
  };
};

export interface ShowReportsOrdersAction extends Action<typeof SHOW_REPORTS_ORDER_ACTION_MODAL> {}

export interface HideReportsOrdersAction extends Action<typeof HIDE_REPORTS_ORDER_ACTION_MODAL> {}

export interface ShowReportsOrdersEdit extends Action<typeof SHOW_REPORTS_ORDER_EDIT_MODAL> {}

export interface HideReportsOrdersEdit extends Action<typeof HIDE_REPORTS_ORDER_EDIT_MODAL> {}

export interface ShowReportsOrdersClone extends Action<typeof SHOW_REPORTS_ORDER_CLONE_MODAL> {}

export interface HideReportsOrdersClone extends Action<typeof HIDE_REPORTS_ORDER_CLONE_MODAL> {}

export interface ShowReportsOrdersDelete extends Action<typeof SHOW_REPORTS_ORDER_DELETE_MODAL> {}

export interface HideReportsOrdersDelete extends Action<typeof HIDE_REPORTS_ORDER_DELETE_MODAL> {}
export interface SetReportOrderByStatusAction extends Action<typeof SET_REPORTS_ORDER_BY_STATUS> {
  readonly payload: ReadonlyArray<OrderReportTable>;
}
export interface SetOrderReportAction extends Action<typeof SET_ORDER_REPORTS> {
  readonly payload: ReadonlyArray<OrderReportTable>;
}

export interface SetTemporaryOrderReportAction extends Action<typeof SET_TEMP_ORDER_REPORTS> {
  readonly payload: ReadonlyArray<OrderReportTable>;
}

export interface SetTempDriverAction extends Action<typeof SET_TEMP_DRIVER_PERMIT> {
  readonly payload: ReadonlyArray<OrderReportTable>;
}
export type ReportsOrdersAction =
  | ShowReportsOrdersAction
  | HideReportsOrdersAction
  | ShowReportsOrdersEdit
  | HideReportsOrdersEdit
  | ShowReportsOrdersClone
  | HideReportsOrdersClone
  | ShowReportsOrdersDelete
  | HideReportsOrdersDelete
  | SetReportOrderByStatusAction
  | SetOptionFieldsAction
  | SetOrderFulfillmentsAction
  | SetOrderSummaryAction
  | SetOrderReportAction
  | SetTemporaryOrderReportAction
  | SetTempDriverAction;
